// extracted by mini-css-extract-plugin
module.exports = {"hidden":"urlShareButton_hidden__MqAl7","textEmphasis":"urlShareButton_textEmphasis__YPZxX","btnShare":"urlShareButton_btnShare__LCgpP","url":"urlShareButton_url__c9If2"};